module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app"
  }, [_c('div', {
    staticClass: "app-body"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('router-view')], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b0e08f5e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/containers/Basic.vue
// module id = 771
// module chunks = 0